export const partnerTestimonials = [
  {
    quote: "Eventium has proudly been one of Entegy's partners chosen since 2017. Exclusively promoting the Entegy Suite has enabled us to confidently provide our clients with a robust and well trusted platform that we know continues to deliver above and beyond any other event technology in the world.",
    name: 'Simone Badcock',
    role: 'Business Operations Manager at Eventium',
    company: 'Eventium',
    logo: '/images/testimonials/eventium.png'
  },
  {
    quote: "Our rich partnership with Entegy is a fundamental part of Upstream Events' continued growth and the key to more exciting opportunities ahead.",
    name: 'Jeff Hamm',
    role: 'CEO at Upstream Events',
    company: 'Upstream Events',
    logo: '/images/testimonials/upstream-events.png'
  },
  {
    quote: "Entegy provides one system to seamlessly control all the various moving parts of your event from attendee interactivity, to exhibitor lead generation. The Entegy Platform helped Harcourts realise their goal of increasing attendee engagement and communication",
    name: 'Jennie Harrison',
    role: 'Head of Events NZ at Harcourts',
    company: 'Harcourts',
    logo: '/images/testimonials/harcourts.png'
  }/*
  {
    quote: "The Entegy platform has been an essential partner for our kiosk solutions. Its consistent reliability ensures our hardware operates seamlessly, making it a vital component of our success in the events industry.",
    name: 'Keith Findlay',
    role: 'CEO at Klay Event Technology',
    company: 'Klay',
    logo: '/images/testimonials/klay-logo.png'
  }*/,
  {
    quote: "I found the app so easy and really enjoyed working on it and developing it further. I would definitely recommend the app far and wide",
    name: 'Master Electricians NZ',
    role: '',
    company: 'Master Electricians',
    logo: '/images/testimonials/master-electricians.png'
  }
]
